import lighten from 'polished/lib/color/lighten';
import shade from 'polished/lib/color/shade';
import tint from 'polished/lib/color/tint';
import { colors as colors$1, darkColors as darkColors$1 } from '../base/colors.js';

const brandColors = {
  orange: '#ec6730',
  // #ED6B3C / #FF6129 - app and current web colours
  teal: '#00999d',
  dark: '#212121',
  light: '#fff'
};
const brandAccents = {
  red: 'red',
  purple: '#2f1681',
  lightTeal: lighten(0.12, brandColors.teal),
  softOrange: '#ffb13d'
};
const palette = {
  primary: {
    light: lighten(0.08, brandColors.teal),
    main: brandColors.teal,
    dark: shade(0.16, brandColors.teal),
    contrastText: brandColors.light,
    contrastTextLight: brandColors.dark
  },
  secondary: {
    light: tint(0.16, brandColors.orange),
    main: brandColors.orange,
    dark: shade(0.16, brandColors.orange),
    contrastText: brandColors.light,
    contrastTextLight: brandColors.dark
  }
};
const text = {
  text: brandColors.dark,
  textMuted: '#707070',
  contrastText: brandColors.light
};
const darkText = {
  text: brandColors.light,
  textMuted: '#ececec',
  contrastText: brandColors.dark
};

/** Neutral shades for borders etc. */
const accents = {
  light: tint(0.85, brandColors.teal),
  // #DBEFEF
  dark: brandColors.dark,
  muted: '#ececec'
};
const darkAccents = {
  ...accents,
  muted: '#707070'
};

/** The main colors are used in all parts of the app, regardless of palette. */
const overRides = {
  ...palette,
  ...text,
  brandAccents,
  accents,
  background: brandColors.light,
  surface: '#f7f7f7'
};
const colors = {
  ...colors$1,
  ...overRides
};
const darkColors = {
  ...darkColors$1,
  ...overRides,
  ...darkText,
  accents: darkAccents,
  background: brandColors.dark,
  surface: '#343434'
};

export { colors, darkColors, palette };
